import { useVfm } from 'vue-final-modal';
import VideoMergeModal from '@/modules/viewer/components/modals/videoMerge/VideoMergeModal.vue';
import { useModal } from '@/storybook/modal/useModal';

export const useVideoMergeModal = () => {
  const vfm = useVfm();

  const closeVideoMergeModal = () => {
    return vfm.closeAll();
  };

  const showVideoMergeModal = () => {
    const { open } = useModal(VideoMergeModal);
    return open();
  };

  return { closeVideoMergeModal, showVideoMergeModal };
};
